import * as yup from 'yup';

export type GrantOption = {
  value: number;
  label: string;
};

export default yup.object({
  grantCatalogIds: yup.mixed<number[]>().default([])
});
